import * as io from 'io-ts';
import { boolean, deprecatedType } from '@shared/core/types/common';

const rootDefinition: io.MixedObject<OLO.Config.PredownloadImages> = {
    forLocations: boolean,
    forVenue: deprecatedType,
};

export const predownloadImagesSchema = io.type(rootDefinition);
